// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".D4V0AzG7I5lkVs {\n  font-size: 12px;\n  text-decoration: underline;\n  cursor: pointer;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ctaButton": "D4V0AzG7I5lkVs"
};
export default ___CSS_LOADER_EXPORT___;
